import { render, staticRenderFns } from "./CustomerRegist.vue?vue&type=template&id=48037b03&"
import script from "./CustomerRegist.vue?vue&type=script&lang=js&"
export * from "./CustomerRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports